// LEGACY OVERSEER DC SELECT
import '../legacy_jquery'

const ready_overseer_dc_select = () => {
  $("body").on("change", "select.overseer-dc-select", function () {
    const row = $(this).closest('.overseer_data_center_fields');

    const data_center = $(this).val();
    const index = row.data('index');

    const container = row.find('.overseer_overseer_data_centers_permissions');
    container.find('span.checkbox').remove();

    $.ajax({
      url: '/admin/acs/permissions.json?q[kind_eq]=0&q[data_center_permissions_data_center_id_eq]=' + data_center,
      type: 'GET',
      contentType: 'application/json; charset=utf-8'
    }).done((response) => {
      $.each(response, (i, item) => {
        addCheckbox(container, index, item);
      });
    });
  });

  const addCheckbox = (container, index, item) => {
    const inputs = container.find('input');
    const id = index + inputs.length + 1;
    const span = $('<span />', {
      class: 'checkbox'
    }).appendTo(container);

    const label = $('<label />', {
      for: 'permission_' + id
    }).appendTo(span);

    $('<input />', {
      type: 'checkbox',
      id: 'permission_' + id,
      name: `overseer[overseer_data_centers_attributes][${index}][permission_ids][]`,
      value: item.id
    }).appendTo(label);

    label.append(" " + item.name);
  };
};

$(document).ready(ready_overseer_dc_select);
$(document).on('turbo:load', ready_overseer_dc_select);
